import { render } from "./NFTPage.vue?vue&type=template&id=4060c740&ts=true"
import script from "./NFTPage.vue?vue&type=script&lang=ts"
export * from "./NFTPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__